module.exports = __webpack_public_path__ + "static/media/academics-stats.12cb2e97.jpg";